export interface DashboardStat {
    label: string;
    value: string;
    action?: string;
}

export interface DashboardTrendPoint {
    label: string;
    value: number;
}

export interface DashboardData {
    stats: DashboardStat[];
    trend: DashboardTrendPoint[];
}

export interface DashboardStats {
    totalScrapes: number;
    totalEmails: number;
    runningJobs: number;
    creditsRemaining: number;
}

export interface RecentScrape {
    name: string;
    account: string;
    status: "Completed" | "Running" | "Failed";
    emails: number;
    date: string;
}

import { API_URL } from '../services/api';
const API_BASE_URL = `${API_URL}/api`;

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
    };
};

export async function fetchDashboardStats(): Promise<DashboardStats> {
    try {
        const response = await fetch(`${API_BASE_URL}/dashboard/stats`, {
            headers: getAuthHeaders(),
        });
        if (!response.ok) {
            throw new Error('Failed to fetch dashboard stats');
        }
        const result = await response.json();
        return result.data;
    } catch (error) {
        console.error('Error fetching dashboard stats:', error);
        return {
            totalScrapes: 0,
            totalEmails: 0,
            runningJobs: 0,
            creditsRemaining: 1500
        };
    }
}

export async function fetchDashboardTrend(): Promise<DashboardTrendPoint[]> {
    try {
        const response = await fetch(`${API_BASE_URL}/dashboard/trend`, {
            headers: getAuthHeaders(),
        });
        if (!response.ok) {
            throw new Error('Failed to fetch dashboard trend');
        }
        const result = await response.json();
        return result.data;
    } catch (error) {
        console.error('Error fetching dashboard trend:', error);
        return [
            { label: "Jan", value: 0 },
            { label: "Feb", value: 0 },
            { label: "Mar", value: 0 },
            { label: "Apr", value: 0 },
            { label: "May", value: 0 },
            { label: "Jun", value: 0 },
        ];
    }
}

export async function fetchRecentScrapes(): Promise<RecentScrape[]> {
    try {
        const response = await fetch(`${API_BASE_URL}/dashboard/recent-scrapes`, {
            headers: getAuthHeaders(),
        });
        if (!response.ok) {
            throw new Error('Failed to fetch recent scrapes');
        }
        const result = await response.json();
        return result.data;
    } catch (error) {
        console.error('Error fetching recent scrapes:', error);
        return [];
    }
}

export function createDashboardData(stats: DashboardStats, trend: DashboardTrendPoint[]): DashboardData {
    return {
        stats: [
            { label: "Total Scrapes", value: stats.totalScrapes.toLocaleString(), action: "Action" },
            { label: "Total Emails Scraped", value: stats.totalEmails.toLocaleString() },
            { label: "Running Jobs", value: stats.runningJobs.toString() },
            { label: "Credits Remaining", value: stats.creditsRemaining.toLocaleString() },
        ],
        trend: trend,
    };
}

